import {
  Component,
  ElementRef,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  Renderer2,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivitiesService } from 'src/app/pages/activities/activities.service';
import { ReviewService } from './review.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-review-form',
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, CommonModule],
  templateUrl: './review-form.component.html',
  styleUrls: ['./review-form.component.scss'],
})
export class ReviewFormComponent {
  @Input() receivedData: any;
  @Output() formSent = new EventEmitter<void>();

  @ViewChild('starsRef', { static: true }) starsElement: ElementRef;

  reviewForm: UntypedFormGroup;
  rating: number = 0;

  constructor(
    private activityService: ActivitiesService,
    private formBuilder: UntypedFormBuilder,
    private reloadService: ReviewService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.createForm();
  }

  reloadSibling2() {
    this.reloadService.triggerReload();
  }

  setRating(index) {
    // Empties all the stars so it updates the view
    const stars = this.starsElement.nativeElement.children;

    for (let i = 0; i <= 4; i++) {
      this.renderer.removeClass(stars[i], 'full');
    }

    // Fill the Html star elements
    for (let i = 0; i <= index; i++) {
      this.renderer.addClass(stars[i], 'full');
    }

    this.rating = index + 1;
  }

  createForm() {
    this.reviewForm = this.formBuilder.group({
      name: [null, Validators.required],
      location: [''],
      comments: [''],
    });
  }

  createReview() {
    const review = {
      name: this.reviewForm.get('name').value,
      product: this.receivedData,
      reviewerLocation: this.reviewForm.get('location').value,
      reviewerCountry: '',
      rating: this.rating,
      createdAt: new Date(),
      comments: this.reviewForm.get('comments').value,
      language: 'es',
      channel: 'Venntur',
    };

    console.log(review);

    this.activityService.postReview(review).subscribe(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.log(error);
      }
    );

    this.formSent.emit(null);
    this.reloadSibling2();
  }
}
